<visit-filters #filters></visit-filters>
<visit-free-terms-calendar (onMonthChange)="monthChanged($event)"></visit-free-terms-calendar>
<visit-slot-list (goToSlots)="goToSlots($event)"></visit-slot-list>
